<script setup lang="ts">
import { setUser } from "@sentry/nuxt";

const colorMode = useColorMode();

const color = computed(() =>
  colorMode.value === "dark" ? "#111827" : "white",
);

useHead({
  meta: [
    { charset: "utf-8" },
    { name: "viewport", content: "width=device-width, initial-scale=1" },
    { key: "theme-color", name: "theme-color", content: color },
    { name: "apple-mobile-web-app-title", content: "Teslemetry" },
  ],
  link: [
    { rel: "icon", href: "/favicon.ico" },
    {
      rel: "icon",
      type: "image/png",
      href: "/favicon-96x96.png",
      sizes: "96x96",
    },
    { rel: "icon", type: "image/svg+xml", href: "/favicon.svg" },
    { rel: "shortcut icon", href: "/favicon.ico" },
    {
      rel: "apple-touch-icon",
      sizes: "180x180",
      href: "/apple-touch-icon.png",
    },
    { rel: "manifest", href: "/site.webmanifest" },
  ],
  htmlAttrs: {
    lang: "en",
  },
  script: [
    {
      children: `!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});`,
    },
    {
      children: `window.Beacon('init', '5a00b2a6-cbae-479e-aed3-615652cffa19');`,
    },
  ],
});

useSeoMeta({
  titleTemplate: "%s - Teslemetry",
  //ogImage: "https://teslemetry.com/social-card.png",
  //twitterImage: "https://teslemetry.com/social-card.png",
  //twitterCard: "summary_large_image",
});

if (process.client) {
  const user = useCurrentUser();
  const router = useRouter();
  const route = useRoute();
  const { $paddle } = useNuxtApp();

  onMounted(() => {
    watch(user, (user, prevUser) => {
      if (user) {
        // Login
        setUser({
          id: user.uid,
          username: user.displayName,
          email: user.email,
        });
        if (window.Beacon) {
          window.Beacon("identify", {
            ...(user.email && { email: user.email }),
            ...(user.displayName && { name: user.displayName }),
            ...(user.photoURL && { avatar: user.photoURL }),
            ...(user.uid && { uid: user.uid }),
          });
        }
      } else if (prevUser) {
        // Logout
        if (!["/", "/delete"].includes(route.path)) {
          router.push("/");
        }
        if ($paddle) {
          $paddle.Update({ pwCustomer: {} });
        }
        if (window.Beacon) {
          window.Beacon("logout");
        }
        setUser(null);
      }
    });
  });
}
</script>

<template>
  <div>
    <NuxtLoadingIndicator />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

    <UNotifications />
  </div>
</template>
